import type { SetPlanInfo } from '@az3fr/core';
import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/lib/store';
import { setPlanAdapter } from '@/entities/set-plan/model/set-plan.slice';

const baseSelectors = setPlanAdapter.getSelectors((state: RootState) => state.setPlans);

const selectAllByStepPlanId = createSelector(
	[baseSelectors.selectAll, (_, stepPlanId) => stepPlanId],
	(allSetPlans, stepPlanId): SetPlanInfo[] =>
		allSetPlans.filter((setPlan) => setPlan.stepPlanId === stepPlanId),
);

const setPlanSliceSelectors = {
	...baseSelectors,
	selectAllByStepPlanId,
};

export { setPlanSliceSelectors };
